import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { useApp } from './store.js';
import { initTelegram } from './telegram.js';
import './styles.css';

void initTelegram().then((initData) => useApp.getState().signIn(initData));

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
